// Theme: terra-firme
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'terra-firme',
  name: 'TERRA',
  tagline: 'TERRA',
  description: 'Terra e raizes. Marrom organico profundo.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 250,
  swatches: ['#2A1A0F', '#C4874A', '#3D2818', '#F0E0C8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 10px 30px rgba(0, 0, 0, 0.25)',
      '--shadow-card-active': '0 14px 44px color-mix(in srgb, var(--primary) 18%, transparent)'
    },
    shellClasses: 'font-sans theme-terra'
  },
  colorVars: {
    '--accent': '#C4874A',
    '--accent-foreground': '#2A1A0F',
    '--background': '#2A1A0F',
    '--border': '#7A5A3A',
    '--card': '#3D2818',
    '--card-border-active': 'rgba(196, 135, 74, 0.04)',
    '--card-completed': '#493121',
    '--card-foreground': '#F0E0C8',
    '--card-glow': 'rgba(196, 135, 74, 0.04)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A1A0F',
    '--foreground': '#F0E0C8',
    '--hold-fill': '#C4874A',
    '--input': '#3D2818',
    '--modal-bg': '#2A1A0F',
    '--modal-border': '#7A5A3A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--muted': '#7A5A3A',
    '--muted-foreground': '#DDBA92',
    '--nav-active': '#C4874A',
    '--nav-bg': '#2A1A0F',
    '--popover': '#3D2818',
    '--popover-foreground': '#F0E0C8',
    '--primary': '#C4874A',
    '--primary-foreground': '#2A1A0F',
    '--ring': '#C4874A',
    '--secondary': '#7A5A3A',
    '--secondary-foreground': '#F0E0C8',
    '--streak': '#C4874A',
    '--success': '#22c55e',
    '--success-foreground': '#2A1A0F',
    '--xp': '#C4874A',
    '--xp-bg': '#3D2818'
  },
  resolvedVars: {
    '--accent': '#C4874A',
    '--accent-foreground': '#2A1A0F',
    '--accent-foreground-hsl': '24 47% 11%',
    '--accent-foreground-oklch': 'from #2A1A0F l c h',
    '--accent-hsl': '30 51% 53%',
    '--accent-oklch': 'from #C4874A l c h',
    '--background': '#2A1A0F',
    '--background-hsl': '24 47% 11%',
    '--background-oklch': 'from #2A1A0F l c h',
    '--border': '#7A5A3A',
    '--border-hsl': '30 36% 35%',
    '--border-oklch': 'from #7A5A3A l c h',
    '--border-w': '1px',
    '--card': '#3D2818',
    '--card-border-active': 'rgba(196, 135, 74, 0.04)',
    '--card-completed': '#493121',
    '--card-completed-hsl': '24 38% 21%',
    '--card-completed-oklch': 'from #493121 l c h',
    '--card-foreground': '#F0E0C8',
    '--card-foreground-hsl': '36 57% 86%',
    '--card-foreground-oklch': 'from #F0E0C8 l c h',
    '--card-glow': 'rgba(196, 135, 74, 0.04)',
    '--card-hsl': '26 44% 17%',
    '--card-oklch': 'from #3D2818 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A1A0F',
    '--destructive-foreground-hsl': '24 47% 11%',
    '--destructive-foreground-oklch': 'from #2A1A0F l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F0E0C8',
    '--foreground-hsl': '36 57% 86%',
    '--foreground-oklch': 'from #F0E0C8 l c h',
    '--hold-fill': '#C4874A',
    '--hold-fill-hsl': '30 51% 53%',
    '--hold-fill-oklch': 'from #C4874A l c h',
    '--input': '#3D2818',
    '--input-hsl': '26 44% 17%',
    '--input-oklch': 'from #3D2818 l c h',
    '--modal-bg': '#2A1A0F',
    '--modal-bg-hsl': '24 47% 11%',
    '--modal-bg-oklch': 'from #2A1A0F l c h',
    '--modal-border': '#7A5A3A',
    '--modal-border-hsl': '30 36% 35%',
    '--modal-border-oklch': 'from #7A5A3A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--muted': '#7A5A3A',
    '--muted-foreground': '#DDBA92',
    '--muted-foreground-hsl': '32 52% 72%',
    '--muted-foreground-oklch': 'from #DDBA92 l c h',
    '--muted-hsl': '30 36% 35%',
    '--muted-oklch': 'from #7A5A3A l c h',
    '--nav-active': '#C4874A',
    '--nav-active-hsl': '30 51% 53%',
    '--nav-active-oklch': 'from #C4874A l c h',
    '--nav-bg': '#2A1A0F',
    '--nav-bg-hsl': '24 47% 11%',
    '--nav-bg-oklch': 'from #2A1A0F l c h',
    '--popover': '#3D2818',
    '--popover-foreground': '#F0E0C8',
    '--popover-foreground-hsl': '36 57% 86%',
    '--popover-foreground-oklch': 'from #F0E0C8 l c h',
    '--popover-hsl': '26 44% 17%',
    '--popover-oklch': 'from #3D2818 l c h',
    '--primary': '#C4874A',
    '--primary-foreground': '#2A1A0F',
    '--primary-foreground-hsl': '24 47% 11%',
    '--primary-foreground-oklch': 'from #2A1A0F l c h',
    '--primary-hsl': '30 51% 53%',
    '--primary-oklch': 'from #C4874A l c h',
    '--radius': '14px',
    '--ring': '#C4874A',
    '--ring-hsl': '30 51% 53%',
    '--ring-oklch': 'from #C4874A l c h',
    '--secondary': '#7A5A3A',
    '--secondary-foreground': '#F0E0C8',
    '--secondary-foreground-hsl': '36 57% 86%',
    '--secondary-foreground-oklch': 'from #F0E0C8 l c h',
    '--secondary-hsl': '30 36% 35%',
    '--secondary-oklch': 'from #7A5A3A l c h',
    '--shadow-card': '0 10px 30px rgba(0, 0, 0, 0.25)',
    '--shadow-card-active': '0 14px 44px color-mix(in srgb, var(--primary) 18%, transparent)',
    '--streak': '#C4874A',
    '--streak-hsl': '30 51% 53%',
    '--streak-oklch': 'from #C4874A l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2A1A0F',
    '--success-foreground-hsl': '24 47% 11%',
    '--success-foreground-oklch': 'from #2A1A0F l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(30 51% 53% / 0.15)',
    '--xp': '#C4874A',
    '--xp-bg': '#3D2818',
    '--xp-bg-hsl': '26 44% 17%',
    '--xp-bg-oklch': 'from #3D2818 l c h',
    '--xp-hsl': '30 51% 53%',
    '--xp-oklch': 'from #C4874A l c h'
  }
}
